import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        bpm: 70,
        appel: '',
    },
    mutations: {
        setBpm(state, newbeat){
            state.bpm = parseInt(newbeat);
        },
        setAppel(state, newAppel){
            state.appel = newAppel;
        },
    },
    actions: {

    }
})
